import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { ContextMenuItem } from '@cad-arc';
import { useBroadcast } from '../../common/broadcast-channel/use-broadcast';
import { useViewLocationOnMap } from '../../location/hooks/use-view-location-on-map';
import { EsriMapEntityTypeEnum } from '../../esri/types';

export const ViewOnMapItem = function ViewOnMapItem({
    unitId,
}: {
    unitId: number;
}): React.ReactElement {
    const { postMessage: legacyStoreBroadcastPostMessage } = useBroadcast('legacy-store-broadcast');
    const viewLocationOnMap = useViewLocationOnMap();
    const { disableLegacyMapAndSearches, mapWindowEnabled } = useEnabledFeatures();

    return (
        <ContextMenuItem
            onSelect={() => {
                if (disableLegacyMapAndSearches || mapWindowEnabled) {
                    viewLocationOnMap({
                        entityId: unitId,
                        entityType: EsriMapEntityTypeEnum.UNIT,
                    });
                } else {
                    legacyStoreBroadcastPostMessage({
                        type: 'SHOW_UNIT_ON_AVL_MAP',
                        payload: { unitId },
                    });
                }
            }}
        >
            View On Map
        </ContextMenuItem>
    );
};
